import React from "react";
import Header from "./Header";
import PropTypes from "prop-types";
import { Box, Typography, Backdrop, Modal, Fade } from "@mui/material";
import { Iconify } from "../../components";
import { RegularButton } from "../../components";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "75%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    height: "100%",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    right: 0,
    margin: "auto",
    overflow: "auto",
  },
  root: {
    padding: theme.spacing(3),
  },
  close: {
    position: "absolute",
    top: 10,
    right: 10,
    border: 0,
    padding: 0,
    fontSize: 30,
    backgroundColor: "transparent",
  },
}));
export default function Index(props) {
  const { titulo, openModal, isNew, content, icono, cerrarModal } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    cerrarModal();
  };
  return (
    <Box>
      {isNew && (
        <RegularButton
          size="small"
          onClick={() => {
            handleOpen();
          }}
          variant="contained"
        >
          <Iconify icon={icono} color={"#fff"} />
          {titulo}
        </RegularButton>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={`${classes.paper} scroll`}>
            <div className={classes.root}>
              <Header titulo={titulo} onClick={handleClose} />
              {content}
            </div>
          </div>
        </Fade>
      </Modal>
    </Box>
  );
}

Index.propTypes = {
  titulo: PropTypes.string,
  icono: PropTypes.string,
  openModal: PropTypes.bool,
  isNew: PropTypes.bool,
  content: PropTypes.node.isRequired,
  cerrarModal: PropTypes.func,
};
Index.defaultProps = {
  titulo: "Nuevo",
  icono: "material-symbols:edit",
  isNew: false,
  cerrarModal: (value) => {},
};
